import { render, staticRenderFns } from "./topUpCard.vue?vue&type=template&id=2ee6e2ca&"
import script from "./topUpCard.vue?vue&type=script&lang=js&"
export * from "./topUpCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports